import { Component, Element, Listen } from '@stencil/core';

@Component({
    tag: 'sew-ws-gsap',
    styleUrl: 'sew-ws-gsap.scss',
    shadow: false,
})
export class SewWsGsap {
    @Element() host: HTMLSewWsGsapElement;

    private resizeTimeout;
    private headerElement: HTMLSewWsHeaderElement;
    private innerWidth = window.innerWidth;
    private preventVerticalMobileResize = true;
    //private resizeObserver = new ResizeObserver(this.handleResize);

    private isMobileDevice() {
        return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    }

    @Listen('resize', { target: 'window' })
    public handleResize() {
        if (
            this.preventVerticalMobileResize &&
            this.isMobileDevice() &&
            window.innerWidth === this.innerWidth
        )
            return;

        this.innerWidth = window.innerWidth;

        if (this.resizeTimeout) {
            clearTimeout(this.resizeTimeout);
        }

        this.resizeTimeout = setTimeout(() => {
            const elements = this.host.querySelectorAll('.hydrated');

            const elementsArray = Array.from(elements);

            async function animateElements(elementsArray) {
                for (const element of elementsArray) {
                    if ((element as any).gsapResize) {
                        await (element as any).gsapResize();
                    }
                }
            }

            animateElements(elementsArray);
        }, 1000);
    }

    public componentDidLoad(): void {
        // ensure all images are not lazy loaded
        const images = document.querySelectorAll('sew-picture');

        images.forEach(image => {
            image.showImage = true;
        });

        // wait for breadcrumb to be ready
        this.headerElement = document.querySelector('sew-ws-header, sew-ws-header-devmode');

        // @TODO: do we need this after having a body height observer to reinitilaize gsap?
        if (!this.headerElement || (this.headerElement && this.headerElement.breadcrumbReady)) {
            //console.log('case 1');
            this.waitForImages();
        } else {
            document.addEventListener('componentDidRenderEvent', this.waitForHeaderBreadcrumbReady);
        }

        //this.resizeObserver.observe(document.body);
    }

    private waitForHeaderBreadcrumbReady = (): void => {
        //console.log('componentDidRenderEvent');

        if (this.headerElement.breadcrumbReady) {
            document.removeEventListener('componentDidRenderEvent', this.waitForHeaderBreadcrumbReady);
            this.waitForImages();
        }
    };

    private waitForImages = (): void => {
        //console.log('waitForImages');
        const images = document.querySelectorAll('sew-picture');

        //console.log(images);

        // ensure that all images are loaded before initializing gsap
        for (let i = 0; i < images.length; i++) {
            const picture = images[i] as HTMLSewPictureElement;
            //console.log(picture, picture.sewPictureComplete);
            if (!picture.sewPictureComplete) {
                picture.addEventListener('sewPictureLoaded', this.waitForImages, { once: true });
                return;
            }
        }

        this.bootstrap();
    };

    private bootstrap(): void {
        setTimeout(() => {
            //console.log('bootstrap');

            const elements = this.host.querySelectorAll('.hydrated');

            const elementsArray = Array.from(elements);

            async function animateElements(elementsArray) {
                for (const element of elementsArray) {
                    if ((element as any).gsapBootstrap) {
                        await (element as any).gsapBootstrap();
                    }
                }
            }

            animateElements(elementsArray);
        }, 200);
    }
}
